import { getCzechSuklRsAtcGroupsAutocomplete } from '~/libs/infrastructure/api/availability';

import { SearchAutocompleteItem } from '../components/SearchAutocomplete';
import { buildSlugFromLabel, extractAtcCode, matchSlugCandidate, parseAutocompleteLabel } from './availabilitySlug';

export async function resolveAvailabilitySlugItems(slugs: string[]): Promise<Record<string, SearchAutocompleteItem>> {
	const codes = Array.from(new Set(slugs.map(extractAtcCode).filter(Boolean)));
	const responses = await Promise.all(
		codes.map((filter) => getCzechSuklRsAtcGroupsAutocomplete({ filter, perPage: 100 }))
	);

	const candidates = responses.flatMap((response) =>
		response.items.map((item) => {
			const parsed = parseAutocompleteLabel(item.label);
			return {
				id: item.id,
				label: parsed.atc,
				slug: buildSlugFromLabel(item.label),
			};
		})
	);

	return slugs.reduce<Record<string, SearchAutocompleteItem>>((result, requestedSlug) => {
		const match = matchSlugCandidate(requestedSlug, candidates);
		if (match) {
			result[requestedSlug] = match;
		}
		return result;
	}, {});
}
